import styled from 'styled-components'

export const Container = styled.div`
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  height: inherit;

  .div-tamanho {
    height: inherit;
  }

  div.ui.attached.message > div.content {
    margin: 0;
    padding: 0;
  }

  div.table-container {
    margin-top: 10px;
  }
`

export const ContainerTab = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`
